import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from 'src/routes/PrivateRoute';
import PublicRoute from 'src/routes/PublicRoute';
import {
  SignupAccountPage,
  SignupBookCallPage,
  SignupCompanyInfoPage,
  SignupPaymentPage,
  SignupPhoneNumberPage,
  SignupPlanPage,
  SignupResumePage,
  SignupVerifyEmailPage,
} from '../pages';
import { SignupStepRoute } from './SignupStepRoute';

export const routes = (
  <>
    <Route
      path="/signup"
      element={
        <PublicRoute>
          <SignupPlanPage />
        </PublicRoute>
      }
    />
    <Route
      path="/signup/account"
      element={
        <PublicRoute>
          <SignupAccountPage />
        </PublicRoute>
      }
    />
    {/*
      Not a PublicRoute, unlike the two above: this is the route the emailed link points at, so it is
      opened in whatever browser the mail was read in. PublicRoute sends an authenticated visitor to
      /home, which would silently swallow the confirmation for anyone already signed in elsewhere.
    */}
    <Route path="/signup/verify" element={<SignupVerifyEmailPage />} />
    {/*
      Unwrapped for the same reason, one screen on: the confirmation above sends the client here, and in a
      browser already signed in as somebody else PublicRoute would answer with /home — with the emailed link
      spent and the form that raises the account out of reach. The funnel token is what gates this screen.
    */}
    <Route path="/signup/company" element={<SignupCompanyInfoPage />} />
    {/*
      Where the reminder email's link points, and unwrapped for the same reason as the screen above: the mail
      is read in whatever browser it is read in, and PublicRoute would answer a client who happens to be
      signed in with /home instead of the funnel they were asked to come back to.
    */}
    <Route path="/signup/resume" element={<SignupResumePage />} />
    {/*
      The second half of the funnel: the account exists by now and the client is signed in. PrivateRoute
      rather than PublicRoute, which would send them to /home — and rather than no wrapper at all, which
      rendered the screens for a signed-out visitor and left them reading "your company could not be
      resolved" instead of a login form that remembers where they were headed.
    */}
    <Route
      path="/signup/phone-number"
      element={
        <PrivateRoute>
          <SignupStepRoute step="/signup/phone-number">
            <SignupPhoneNumberPage />
          </SignupStepRoute>
        </PrivateRoute>
      }
    />
    <Route
      path="/signup/payment"
      element={
        <PrivateRoute>
          <SignupStepRoute step="/signup/payment">
            <SignupPaymentPage />
          </SignupStepRoute>
        </PrivateRoute>
      }
    />
    {/*
      Where the funnel ends when the application offers a call. No step guard, because this is not a funnel
      step: the funnel is finished by the time the client is sent here, and a guard would answer the screen
      it is standing on with the screen behind it.
    */}
    <Route
      path="/signup/book-call"
      element={
        <PrivateRoute>
          <SignupBookCallPage />
        </PrivateRoute>
      }
    />
  </>
);
